<template>
  <div class="invoice-setting-page">

    <!-- Header -->
    <div class="page-header d-flex justify-content-between align-items-center mb-4">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("invoice_setting") }}</h4>
        </div>
      </div>
<!--		<ul class="table-top-head">-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--			</li>-->
<!--		</ul>-->
      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link to="/invoice/setting/list" class="btn btn-added">
              <span>Back</span>
            </router-link>
          </div>
        </li>
      </ul>
    </div>

    <form @submit.prevent="submitSetting">
      <div class="row">
        <!-- LEFT SIDE -->
        <div class="col-lg-8">
          <!-- BUSINESS INFO -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Business Information</h5>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">
                    {{ $t("business_name") }}
                  </label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.business_name"
                  >
                  <small class="text-danger">
                    {{ errors.business_name }}
                  </small>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">
                    {{ $t("business_phone") }}
                  </label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.business_phone"
                  >
                  <small class="text-danger">
                    {{ errors.business_phone }}
                  </small>
                </div>

                <div class="col-12 mb-3">
                  <label class="form-label">
                    {{ $t("business_address") }}
                  </label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.business_address"
                  >
                  <small class="text-danger">
                    {{ errors.business_address }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- TAX INFO -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Tax Information</h5>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">TIN</label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.tin"
                  >
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">BIN</label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.bin"
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- MESSAGE -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Invoice Messages</h5>
              </div>

              <div class="mb-3">
                <label class="form-label">
                  {{ $t("header_message") }}
                </label>
                <input
                  type="text"
                  class="form-control modern-input"
                  v-model="setting.header_message"
                >
              </div>
              <div>
                <label class="form-label">
                  {{ $t("footer_message") }}
                </label>
                <input
                  type="text"
                  class="form-control modern-input"
                  v-model="setting.footer_message"
                >
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT SIDE -->
        <div class="col-lg-4">
          <!-- LOGO -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Upload invoice logo</h5>
              </div>
              <div class="logo-upload">
                <div class="logo-preview mb-3">
                  <img
                    v-if="logoPreview"
                    :src="logoPreview"
                    class="preview-image"
                  >
                  <div v-else class="empty-logo">
                    Upload Logo
                  </div>
                </div>
                <input
                  type="file"
                  class="form-control modern-input"
                  @change="handleLogoUpload"
                >
              </div>
            </div>
          </div>

          <!-- SETTINGS -->
          <div class="card custom-card">
            <div class="card-body">
              <div class="section-title">
                <h5>Display Settings</h5>
              </div>

              <div class="setting-item">
                <span>Show Logo</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.show_logo"
                  >
                </div>
              </div>

              <div class="setting-item">
                <span>Show TIN</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.show_tin"
                  >
                </div>
              </div>

              <div class="setting-item">
                <span>Show BIN</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.show_bin"
                  >
                </div>
              </div>

              <div class="setting-item border-0 pb-0">
                <span>Powered By</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.powered_by"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ACTION BUTTON -->
      <div class="text-end mt-0">
        <button
          type="button"
          class="btn btn-light border px-4 py-2 me-2 rounded-pill"
          @click="cancelForm"
        >
          {{ $t('cancel') }}
        </button>

        <button
          type="submit"
          class="btn btn-primary px-4 py-2 rounded-pill"
        >
          {{ $t('submit') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import VueSelect2 from "vue3-select2-component";
import {useToast} from "vue-toastification";

export default {
  components: {
    Vue3Datepicker,
    VueSelect2,
  },

  data() {
    return {
      logoPreview: null,
      setting: {
        business_name: '',
        business_address: '',
        business_phone: '',
        tin: '',
        show_tin: true,
        bin: '',
        show_bin: true,
        header_message: '',
        footer_message: '',
        logo: null,
        show_logo: true,
        powered_by: true,

      },

      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {
    async submitSetting() {
      // Frontend validation before making API call
        this.errors = {};
        if (!this.setting.business_name) this.errors.business_name = this.$t('error.required');
        if (!this.setting.business_address) this.errors.business_address = this.$t('error.required');
        if (!this.setting.header_message) this.errors.header_message = this.$t('error.required');
        if (!this.setting.footer_message) this.errors.footer_message = this.$t('error.required');
        if (!this.setting.powered_by) this.errors.powered_by = this.$t('error.required');

        if (Object.keys(this.errors).length > 0) {
          return;
      }

      try {
        const formData = new FormData();

        for (const key in this.setting) {
          formData.append(key, this.setting[key]);
        }

        // if your API expects JSON
        const response = await this.$axios.post(apiUrls.invoice_setting.post, formData,
                {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );

        this.toast.success('inventory setting successfully created!')

        // Redirect only after successful response
        this.$router.push('/invoice/setting/list');

        // Emit event to update parent component
        this.$emit("create_success");

        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        // Handle field-specific errors dynamically
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
      }
    },

    handleLogoUpload(event) {
      this.setting.logo = event.target.files[0];

      if (this.setting.logo) {
        this.logoPreview = URL.createObjectURL(this.setting.logo)
      }
    },

    cancelForm() {
        this.$router.push('/invoice/setting/list');
      },

    resetForm() {
      // Reset form fields and errors
      this.setting = {
        business_name: '',
        business_address: '',
        business_phone: '',
        tin: '',
        show_tin: true,
        bin: '',
        show_bin: true,
        header_message: '',
        footer_message: '',
        logo: null,
        show_logo: true,
        powered_by: true,
      };
      this.errors = {};
      this.errorMessage = "";
    },
  },
};
</script>
